"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectGeneratorNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'OBJECT-GENERATOR';
class ObjectGeneratorNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const ret = { output: {} };
            Object.values(this.config.props).forEach((item) => {
                ret.output[item[1]] = params[item[1]];
            });
            return ret;
        };
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //set up the basic outputParams schema
        const OutputParams = {
            type: 'object',
            properties: {
                output: {
                    type: 'object',
                    description: 'Output',
                    properties: {},
                },
            },
        };
        const InputParams = {
            type: 'object',
            properties: {},
        };
        if (this.config.props) {
            Object.values(this.config.props).forEach((item) => {
                InputParams.properties[item[1]] = BaseNode_1.BaseNode.getProp(item[0], item[1]);
                OutputParams.properties.output.properties[item[1]] = BaseNode_1.BaseNode.getProp(item[0], item[1]);
            });
        }
        return Object.assign(Object.assign({}, Schema), { InputParams: InputParams, OutputParams: OutputParams, ConfigParams: {
                type: 'object',
                properties: {
                    props: {
                        type: 'array',
                        title: 'Properties',
                        description: 'Properties',
                        items: {
                            type: 'array',
                            items: [
                                BaseNode_1.BaseNode.getTypeOptions(true),
                                {
                                    description: 'Key',
                                    type: 'string',
                                },
                            ],
                            minItems: 2,
                            maxItems: 2,
                        },
                    },
                },
            } });
    }
}
exports.ObjectGeneratorNode = ObjectGeneratorNode;
ObjectGeneratorNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Object Generator',
    isIdempotent: true,
    primaryCategory: 'Collection',
};
//# sourceMappingURL=ObjectGenerator.js.map